import React, { useState } from "react";
import urlParser from "js-video-url-parser/dist/jsVideoUrlParser.js?v=1.2";

export default function AddVideo(props) {
    const [videoUrl, setVideoUrl] = useState("");
    const [errors, setErrors] = useState({});

    const validate = () => {
        const errors = {};
        if (!videoUrl || (videoUrl && videoUrl.trim() == "")) {
            errors.videoUrl = "Add video link to gallery is required";
        }
        setErrors(errors);
        return Object.keys(errors).length === 0;
    }

    const addHandler = () => {
        if (validate()) {
            let parsedData = urlParser.parse(videoUrl);
            if (parsedData && parsedData?.id && parsedData.id != "") {
                return props.addVideo(videoUrl, parsedData.id);
            }
            else {
                const errors = {};
                errors.videoUrl = "Invalid youtube Url";
                setErrors(errors);
            }
        }
    }

    return (
        <div className="modal fade show" aria-modal="true" role="dialog" style={{ display: "block" }}>
            <div className="modal-dialog modal-md modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Add Video Link to Gallery</h5>
                        <button type="button" className="btn-close" onClick={props.onClose}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3">
                            <label className="form-label">Video Link<span style={{ color: "red", marginLeft: "4px" }}>*</span></label>
                            <input id="video-link" type="text" className={`form-control ${errors.videoUrl ? "is-invalid" : ""}`}
                                value={videoUrl} onChange={(e) => setVideoUrl(e.target.value)} />
                            <small>Add any public Youtube link</small>
                            {errors.videoUrl && (
                                <div className="invalid-feedback">
                                    {errors.videoUrl}
                                </div>
                            )}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary" onClick={addHandler}>Add</button>
                        <button className="btn btn-secondary" onClick={props.onClose}>Cancel</button>
                    </div>
                </div>
            </div>
        </div>
    )
}
